import {Base} from './base'

/**
 * This api contains method used to
 * perform authentication on the server
 * 
 * They are used by vuex store to
 * manage user session
 */
class Auth extends Base
{
	/**
	 * Default constructor
	 * 
	 * @param {VuexStore} store vuex instance
	 */
	constructor(store)
	{
		return super(store)
	}

	/**
	 * Request login with password.
	 * Server responds with user object
	 * and JWT access token
	 * 
	 * @param {String} login username or email
	 * @param {String} password password (in clear)
	 * @return {Promise} data with 'user' and 'access_token'
	 */
	login(login, password) {

		return this._post('/auth/login', {login, password})
	}

	/**
	 * Register using email and password
	 * Server responds with user object
	 * and JWT access token
	 * 
	 * @param {Object} data user data
	 * @return {Promise}
	 */
	register(data) {

		return this._post('/auth/register', data)
	}

	/**
	 * 
	 */
	changePassword(oldPwd, newPwd)
	{
		return this._put('/auth/password', {oldPwd, newPwd}, true)
	}

	/**
	 * TODO:
	 *
	 * @return {Promise}
	 */
	check() {

		return this._get('/auth/check')
	}
}

export default Auth